var React = require('react');

function CoopStep3 (props) {
    return React.createElement("svg",props,React.createElement("g",{"style":{"mixBlendMode":"luminosity"}},[React.createElement("path",{"d":"M78.1814 46.7944L39.4202 70L0.561035 46.7944L39.4202 23.5879L78.1814 46.7944Z","fill":"#EF5261","key":0}),React.createElement("path",{"d":"M78.1814 35.0001L39.4202 58.2057L0.561035 35.0001L39.4202 11.7944L78.1814 35.0001Z","fill":"#69B0EE","key":1}),React.createElement("path",{"d":"M78.1814 23.2057L39.4202 46.4122L0.561035 23.2057L39.4202 0L78.1814 23.2057Z","fill":"#F6C863","key":2})]));
}

CoopStep3.defaultProps = {"width":"79","height":"70","viewBox":"0 0 79 70","fill":"none"};

module.exports = CoopStep3;

CoopStep3.default = CoopStep3;
